<div *ngIf="errors.length || errorMessage" class="error-messages">
  <h3>{{this.errorListTitle || ('validations.formError' | translate)}}</h3>
  <ul>
    <li *ngFor="let error of errors">
      <a [routerLink]="routerLink" [fragment]="error.controlKey" appStopPropagation>{{'validations.errorField' | translate}} "{{error.controlName}}"</a>
      <span>:{{error.error}}</span>
    </li>
    <li *ngIf="errorMessage">
      <p>{{(errorMessage?.message || errorMessage) | translate}}</p>
      <p *ngIf="errorMessage?.additionalInfo">({{errorMessage.additionalInfo | translate}})</p>
    </li>
  </ul>
</div>
